import { Breadcrumbs, Typography, Link, Stack } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { usePrincipalEntregaObrasViewModel } from "../../viewModels/principal_entregaobras_view_model";
import { PrincipaisDocGrid } from "../../../../../common/components/principaisDocGrid";
import { Check, People } from "@mui/icons-material";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GeneratePrincipalCentroCustoColumnDefs } from "./columns";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import StatCard from "../../../../../common/components/statCard";
import StatCardString from "../../../../../common/components/statCardString";
import { AssistenciaTecnicaPieChart } from "./components/assistencia_tecnica_piechart";

/**
 * PrincipalEntregaObras
 */

export const PrincipalEntregaObras = () => {
  const viewModel = usePrincipalEntregaObrasViewModel();

  const columnsDef = useMemo(() => {
    return GeneratePrincipalCentroCustoColumnDefs({
      onRegistradaClick: viewModel.handleRegistradaClick,
      onEmAnaliseClick: viewModel.handleEmAnaliseClick,
      onResolvidaClick: viewModel.handleResolvidaClick,
    });
  }, [
    viewModel.handleRegistradaClick,
    viewModel.handleEmAnaliseClick,
    viewModel.handleResolvidaClick,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[10rem]">
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Entrega de Obras
          </Link>
          <Typography className="text-primary-green">
            Principal Entrega de Obras
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Principal Entrega de Obras</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2"></div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                {
                  viewModel.dashboardEntregaObrasInformation !== null && (
                    <div className="w-full flex flex-col gap-4 mb-8">
                      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                        <StatCard
                          title='Obras Entregues'
                          value={viewModel.dashboardEntregaObrasInformation.obrasEntregues}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-teal-500',
                            text: 'text-white',
                            bgHover: 'bg-teal-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('obrasEntregues')}
                        />

                        <StatCardString
                          title='Satisfação do Cliente Entrega de Obras'
                          value={
                            new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 2 })
                              .format(viewModel.dashboardEntregaObrasInformation.satisfacaoClienteEntregaObras)
                          }
                          icon={People}
                          colorClass={{
                            bg: 'bg-amber-500',
                            text: 'text-white',
                            bgHover: 'bg-amber-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('satisfacaoClienteEntregaObras')}
                        />

                        <StatCardString
                          title='Satisfação do Cliente Assistência Técnica'
                          value={
                            new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 2 })
                              .format(viewModel.dashboardEntregaObrasInformation.satisfacaoClienteAssistenciaTecnica)
                          }
                          icon={People}
                          colorClass={{
                            bg: 'bg-amber-500',
                            text: 'text-white',
                            bgHover: 'bg-amber-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('satisfacaoClienteAssistenciaTecnica')}
                        />

                        <StatCard
                          title='Assistências Técnicas em Aberto Assistência Técnica'
                          value={viewModel.dashboardEntregaObrasInformation.assistenciasTecnicasEmAberto}
                          icon={People}
                          colorClass={{
                            bg: 'bg-amber-500',
                            text: 'text-white',
                            bgHover: 'bg-amber-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('assistenciasTecnicasEmAberto')}
                        />
                      </div>

                      <AssistenciaTecnicaPieChart
                        registradas={viewModel.dashboardEntregaObrasInformation.assistenciasTecnicasRegistradas}
                        emAnalise={viewModel.dashboardEntregaObrasInformation.assistenciasTecnicasEmAnalise}
                        resolvidas={viewModel.dashboardEntregaObrasInformation.assistenciasTecnicasResolvidas}
                      />

                      <Stack spacing={0}>
                        <StyledDataGrid
                          tableName="principal_entrega_obras"
                          disableRowSelectionOnClick={true}
                          disableColumnMenu={false}
                          getRowId={(row: any) => row.idCentroCusto}
                          columns={columnsDef}
                          loading={viewModel.loading}
                          rows={viewModel.dashboardEntregaObrasInformation.assistenciaTecnicaCentroCustos}
                        />

                      </Stack>

                      <PrincipaisDocGrid
                        loading={viewModel.loading}
                        rows={viewModel.docLista}
                        totalItems={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onPageChange={(p) => viewModel.handlePageChange(p)}
                        onRowsPerPageChange={(p) => viewModel.handleRowsPerPageChange(p)}
                        onActionExportar={(IdArquivoModulo, NomeArquivo) =>
                          viewModel.handleDownloadFile(IdArquivoModulo, NomeArquivo)
                        }
                      />
                    </div>
                  )
                }
              </>
            )
        }
      </div>
    </>
  );
}